import React from 'react';
import { translate } from 'react-i18next';
import classnames from 'classnames';

import { Form } from 'common/components';
import Validated from 'components/util/Validated';

import { createRoute } from 'lib/util';

const ProviderForm = ({
  company,
  errors,
  handleSubmit,
  handleValueChange,
  isSaving,
  isSubmitted,
  subcompany,
  t,
  handleGroupChange, //Groups
  handleCustomFieldChange, //Groups
  groups, //Groups
  values,
}) => {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit();
      }}
    >
      <div className="col-md-12 mt-3">
        <div className="row align-items-center">
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Form.FieldInput
              error={(isSubmitted && errors.key) || {}}
              name={'key'}
              label={t('providers.fields.key')}
              handleChange={handleValueChange}
              t={t}
              value={values.key}
            />
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Form.FieldInput
              error={(isSubmitted && errors.name) || {}}
              name={'name'}
              label={t('providers.fields.name')}
              handleChange={handleValueChange}
              t={t}
              value={values.name}
            />
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Form.FieldInput
              error={(isSubmitted && errors.mail) || {}}
              name={'mail'}
              label={t('providers.fields.mail')}
              handleChange={handleValueChange}
              t={t}
              value={values.mail}
            />
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Form.FieldInput
              error={(isSubmitted && errors.telephone) || {}}
              name={'telephone'}
              label={t('providers.fields.telephone')}
              handleChange={handleValueChange}
              t={t}
              value={values.telephone}
            />
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Form.FieldInput
              error={(isSubmitted && errors.rfc) || {}}
              name={'rfc'}
              label={t('providers.fields.rfc')}
              handleChange={handleValueChange}
              t={t}
              value={values.rfc}
            />
          </div>
          <Form.CustomFields
            errors={errors}
            handleCustomFieldChange={handleCustomFieldChange}
            handleGroupChange={handleGroupChange}
            isSubmitted={isSubmitted}
            t={t}
            values={values}
            groups={groups}
          ></Form.CustomFields>
        </div>
      </div>

      <div className="col-md-12 mt-3">
        <Form.Button
          type={'submit'}
          text={t('actions.save')}
          isLoading={isSaving}
          disabled={isSaving}
          extraClassName={'pull-right btn-xs-block'}
        />

        <Form.Link
          to={createRoute(company.id, subcompany.id, `providers`)}
          className={classnames('btn btn-secondary pull-right mr-3', {
            disabled: isSaving,
          })}
        >
          {t('actions.cancel')}
        </Form.Link>
        <div className="clearfix" />
      </div>
    </form>
  );
};

export default Validated({
  type: 'object',
  properties: {
    key: {
      type: 'string',
      minLength: 1,
    },
    name: {
      type: 'string',
      minLength: 1,
    },
    mail: {
      type: 'string',
      minLength: 1,
    },
    telephone: {
      type: 'string',
      minLength: 1,
    },
    rfc: {
      type: 'string',
      minLength: 1,
    },
  },
  required: ['name'],
})(translate()(ProviderForm));



// WEBPACK FOOTER //
// src/modules/secured/modules/providers/components/form/ProviderForm.js